import { COMMUNITY_INVITE_SESSION_KEY } from "./invite-session.constants";
import type { StoredCommunityInviteSession } from "./invite-session.types";

export const getStoredCommunityInviteSession =
	(): StoredCommunityInviteSession | null => {
		const rawSession = window.localStorage.getItem(COMMUNITY_INVITE_SESSION_KEY);

		if (!rawSession) {
			return null;
		}

		try {
			return JSON.parse(rawSession) as StoredCommunityInviteSession;
		} catch {
			window.localStorage.removeItem(COMMUNITY_INVITE_SESSION_KEY);
			return null;
		}
	};

export const storeCommunityInviteSession = (
	session: StoredCommunityInviteSession
) => {
	window.localStorage.setItem(
		COMMUNITY_INVITE_SESSION_KEY,
		JSON.stringify(session)
	);
};

export const clearStoredCommunityInviteSession = () => {
	window.localStorage.removeItem(COMMUNITY_INVITE_SESSION_KEY);
};
